<template>
  <div id="app">
    <div class="gotops" v-if="go_top>800" @click="go_tops">
      <img src="@/assets/backtop.png" alt="">
    </div>
    <headerComponent />
    <router-view />
    <footerComponent />
    <!-- <img  v-for="item in 1" :key="item" v-lazy="require('./assets/logo.png')"> -->
  </div>
</template>

<script>
import headerComponent from "@/components/headerComponent/headerComponent.vue";
import footerComponent from "@/components/footerComponent/footerComponent.vue";
import { setToken , getToken } from "../static/js/util.js";
import { mapMutations } from "vuex"
import { getUserInfo } from "@/api/lxc";
import { async } from 'q';
export default {
  name: "App",
  data() {
    return {
      // 距离顶部单位
      go_top: 0,
      nihao: "./assets/logo.png"
    };
  },
  computed:{
    logoimg(){
      return require("./assets/logo.png")
    }
  },
  created () {
    let unique_code=getToken("unique_code");
    if(unique_code){
      this.getUserInfoFn(unique_code)
    }
  },
  mounted() {
    // 进入页面监听高度
    window.addEventListener("scroll", this.gt);
  },
  methods: {
    ...mapMutations([
          "setUserInfo",
          "unique_code"
      ]),
    async getUserInfoFn(unique_code_val){
      try{ 
        const data=await getUserInfo({
          unique_code:unique_code_val
        }) 
        this.setUserInfo(data)
        this.unique_code(unique_code_val)
      }catch(err){

      }
    },
    // 监听高度方法
    gt() {
      this.go_top =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
    },
    // 点击回到顶部
    go_tops(){
        let ispeed = Math.floor(-this.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = this.go_top + ispeed
    }
  },
  components: {
    headerComponent,
    footerComponent
  }
};
</script>

<style>
.gotops {
  width: 50px;
  height: 50px;
  background: #0083f1;
  border-radius: 10px 0 0 10px;
  color: #fff;
  font-weight: 600;
  text-align: center;
  line-height: 50px;
  cursor: pointer;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: 300px;
  right: 0;
  z-index: 100;
}
.gotops img{
  width: 50%;
}
@font-face {
  font-family: "pingFang";  
  src: url("./assets/fonts/pingfang.ttf");  
} 
#app {
  /* font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; */
  font-family: pingFang!important; 
  color: #2c3e50;
}
a {
  text-decoration: none;
}
a:link {
  color: #152f6a;
}
a:active {
  color: #152f6a;
}
a:visited {
  color: #152f6a;
}
a:hover {
  color: #152f6a;
  text-decoration: none;
}

.home_title {
  width: 1200px;
  text-align: center;
  font-size: 40px;
  font-weight: 600;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  height: 80px;
  line-height: 80px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  margin: 0 auto;
}

.personal-center-title {
  width: 100%;
  height: 60px;
  font-size: 18px;
  font-weight: 700;
  color: rgba(58, 58, 58, 1);
  line-height: 60px;
  padding-left: 40px;
  box-sizing: border-box;
  box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.1);
  background: rgb(244,244,244);
}

.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #ecf5ff;
  color: #1966ff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue